export const createAuxData = (content) => {
    return new Map(content);
};
export const AUXDATA_LENGTH = 1024;
export const CRYPTO_IV_LENGTH = 12;
export const CRYPTO_TAG_LENGTH = 16;
export const CRYPTO_KEY_LENGTH = 32;
export var CryptoAlgorithm;
(function (CryptoAlgorithm) {
    CryptoAlgorithm["AES_GCM"] = "AES-GCM";
    CryptoAlgorithm["DEFAULT"] = "AES-GCM";
})(CryptoAlgorithm || (CryptoAlgorithm = {}));
export var AuxDataKey;
(function (AuxDataKey) {
    AuxDataKey["CRYPTO_IV"] = "iv";
    AuxDataKey["CRYPTO_CHECKSUM"] = "tag";
    AuxDataKey["METADATA_UPDATE"] = "metadata";
    AuxDataKey["DATA_COMPRESSION_SCHEME"] = "compr_scheme";
    AuxDataKey["DATA_UNCOMPRESSED_SIZE"] = "raw_size";
})(AuxDataKey || (AuxDataKey = {}));
